import React, { Component } from 'react';
import { Link } from "react-router-dom";

export class Timeline extends Component {
  static displayName = Timeline.name;

  render () {
    return (
      <div>
        {/* Hero */}
      <section className="hero-timeline container" style={{padding:"20px 0 0px"}}>
        {/* <div className="text">
          <h1>Life Journey Timeline</h1>
          <p>
            Explore the sacred journey of Swami Brahmanand Saraswati Ji Maharaj —
            from divine birth in 1902 to spiritual legacy in 2021, chapter by chapter.
          </p>
        </div> */}

        <div className="image">
          <div className="aura"></div>
          <img
            src="/images/IMG_5427-removebg-preview.png"
            alt="Swami Brahmanand Ji" style={{maxWidth:"250px"}}
          />
        </div>
      </section>

      {/* Timeline Section */}
      <section className="timeline-section container">
        <h2>गुरु देव जी दिव्य यात्रा</h2>

        <div className="timeline">

          {/* 1902 */}
          <div className="timeline-item left">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>1902 — दिव्य अवतरण</h3>
              <Link to="/Chapter1">पढ़ें...</Link>
            </div>
          </div>

          {/* 1918 */}
          <div className="timeline-item right">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>गुरुदेव की बाल-लीला</h3>
              <Link to="/Chapter2">पढ़ें...</Link>
            </div>
          </div>

          {/* 1930 */}
          <div className="timeline-item left">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>घर का त्याग: विरक्ति की ज्वाला और सन्यास का प्रथम आह्वान</h3>
              <Link to="/Chapter3">पढ़ें...</Link>
            </div>
          </div>

          {/* 1941 */}
          <div className="timeline-item right">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>कठोर तपस्या, वनवास और प्रथम सिद्धियाँ</h3>
              <Link to="/Chapter4">पढ़ें...</Link>
            </div>
          </div>

          {/* 1953 */}
          <div className="timeline-item left">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>बाल तेज, विद्रोह का शमन और श्मशान-तप का रहस्य</h3>
              <Link to="/Chapter5">पढ़ें...</Link>
            </div>
          </div>

          {/* 1960 */}
          <div className="timeline-item right">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>अध्यात्म-जागरण और आत्मा में उठता दिव्य प्रकाश</h3>
              <Link to="/Chapter6">पढ़ें...</Link>
            </div>
          </div>

          {/* 1985 */}
          <div className="timeline-item left">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>घर-त्याग, गुरु-दर्शन और दिव्य वन-तप</h3>
              <Link to="/Chapter7">पढ़ें...</Link>
            </div>
          </div>

          {/* 2021 */}
          <div className="timeline-item right">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>श्मशान की तपोभूमि और माँ बगलामुखी की कृपा</h3>
              <Link to="/Chapter8">पढ़ें...</Link>
            </div>
          </div>

          <div className="timeline-item left">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>सिद्धियों का प्रकाश और शिष्यों पर गुरु-शक्ति का प्रभाव</h3>
              <Link to="/Chapter9">पढ़ें...</Link>
            </div>
          </div>

          <div className="timeline-item right">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>पर्वत, गुफाएँ और ऋषि-लोक से प्राप्त दिव्य ज्ञान</h3>
              <Link to="/Chapter10">पढ़ें...</Link>
            </div>
          </div>

          <div className="timeline-item left">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>ज्ञान-प्रकाश : वाणी जो अंधकार को चीर दे</h3>
              <Link to="/Chapter11">पढ़ें...</Link>
            </div>
          </div>

          <div className="timeline-item right">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>चमत्कार नहीं, दिव्य-स्वभाव : गुरुदेव के अद्भुत प्रसंग</h3>
              <Link to="/Chapter12">पढ़ें...</Link>
            </div>
          </div>

          <div className="timeline-item left">
            <div className="content">
              <h3 style={{fontSize:"1.25rem"}}>अंतिम वर्षों की दिव्य लीला और अमर संदेश</h3>
              <Link to="/Chapter13">पढ़ें...</Link>
            </div>
          </div>

        </div>
      </section>
      </div>
    );
  }
}